var map = {
	"./arrow-fill.svg": 155,
	"./back-arrow.svg": 156,
	"./bell.svg": 157,
	"./caret-down.svg": 158,
	"./caret-left.svg": 159,
	"./caret-right.svg": 160,
	"./check.svg": 161,
	"./checkbox--off.svg": 162,
	"./checkbox--on.svg": 163,
	"./close.svg": 164,
	"./controls.svg": 165,
	"./delete.svg": 166,
	"./error.svg": 167,
	"./flag-off.svg": 168,
	"./flag-on.svg": 169,
	"./heart.svg": 170,
	"./helpful-off.svg": 171,
	"./helpful-on.svg": 172,
	"./info.svg": 173,
	"./logout.svg": 174,
	"./moderate.svg": 175,
	"./more-H.svg": 176,
	"./next-arrow.svg": 177,
	"./options-collapse.svg": 178,
	"./options-expand.svg": 179,
	"./photo.svg": 180,
	"./posts.svg": 181,
	"./profile.svg": 182,
	"./question.svg": 183,
	"./quote.svg": 184,
	"./reply.svg": 185,
	"./search.svg": 186,
	"./settings.svg": 187,
	"./social-facebook.svg": 188,
	"./social-google.svg": 189,
	"./social-pinterest.svg": 190,
	"./social-twitter.svg": 191,
	"./sort.svg": 192,
	"./star--empty.svg": 193,
	"./star--full.svg": 194,
	"./star--half.svg": 195,
	"./unhelpful-off.svg": 196,
	"./unhelpful-on.svg": 197,
	"./video.svg": 198,
	"./vote-off.svg": 199,
	"./vote-on.svg": 200,
	"./write.svg": 201
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 154;


//////////////////
// WEBPACK FOOTER
// ./src/build/VuTUYdwvqIExdDFsite/assets/svg/non-defined-page .svg$
// module id = 154
// module chunks = 11